var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-794.000000, -1694.000000)",
    strokeWidth: 1.57248
  }, /*#__PURE__*/React.createElement("g", {
    id: "item_destaque_1",
    transform: "translate(682.180272, 1322.474020)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(113.000000, 370.006498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(0.000000, 2.395062)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.79137095,
    y1: 0,
    x2: 4.79137095,
    y2: 2.94530876,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7950165,
    y1: 0,
    x2: 10.7950165,
    y2: 2.94530876,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.383339652,
    y1: 5.75564887,
    x2: 15.074953,
    y2: 5.2745739,
    id: "Vector",
    transform: "translate(7.729146, 5.515111) rotate(1.875473) translate(-7.729146, -5.515111) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5863874,11.6299895 C15.5863874,14.0180777 14.2875218,15.6101365 11.2568354,15.6101365 L4.32955207,15.6101365 C1.29886562,15.6101365 0,14.0180777 0,11.6299895 L0,4.86373961 C0,2.47565142 1.29886562,0.883592629 4.32955207,0.883592629 L11.2568354,0.883592629 C14.2875218,0.883592629 15.5863874,2.47565142 15.5863874,4.86373961 L15.5863874,11.6299895 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5659043,
    y1: 8.924252,
    x2: 10.5726449,
    y2: 8.924252,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5659043,
    y1: 11.9677377,
    x2: 10.5726449,
    y2: 11.9677377,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.78980458,
    y1: 8.924252,
    x2: 7.79654513,
    y2: 8.924252,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.78980458,
    y1: 11.9677377,
    x2: 7.79654513,
    y2: 11.9677377,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.01223908,
    y1: 8.924252,
    x2: 5.01897963,
    y2: 8.924252,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.01223908,
    y1: 11.9677377,
    x2: 5.01897963,
    y2: 11.9677377,
    id: "Vector"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.050882a7a3ca0074769ce68a6f30b405.svg";
export { ForwardRef as ReactComponent };